export const MODAL_DISPLAYED = 'SHOW_MODAL';

export const modalDisplayed = payload => dispatch =>
  dispatch({
    type: MODAL_DISPLAYED,
    payload,
  });
